import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { css } from "styled-components";

productImageStyles.compareCheckbox = {
    css: css`
        align-self: center;
        padding-top: 20px;
    `,
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
};
